exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "p[data-v-70e15f25]{margin-top:5px;margin-bottom:5px}h3[data-v-70e15f25]{margin-bottom:0;margin-top:0}.md-field[data-v-70e15f25]{margin-bottom:0}.md-button[data-v-70e15f25]{font-size:12px}.md-field .md-textarea[data-v-70e15f25]{max-height:100%}#message-container[data-v-70e15f25]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-70e15f25","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/chatMessagesWindow.vue
// module id = 422
// module chunks = 0